import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    paddingVertical: 28,
    paddingHorizontal: 16,
  },
  title: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
});
